<template>
  <div class="shortlist" v-if="!$store.getters['user/isLister']">
    <div class="shortlist-trigger">
      <a
          @click="toggleFocus"
        >
          <span class="shortlist-trigger__text">Shortlist</span>
          <span type="button" class="transparent interactive add-to-shortlist">
            <svg-icon id="shortlistOutline" v-if="inAnyShortlist" class="active shortlist-selected"></svg-icon>
            <svg-icon id="shortlistOutline" v-else class="active"></svg-icon>
          </span>
        </a>
      </div>
  </div>
</template>

<script>

export default {
  name: "ShortlistButton",
  props: {
    listing: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    setShowShortlistMenu: {
      type: Function
    }
  },
  data() {
    return {
      isSelected: this.selected,
    };
  },
  computed: {
    inAnyShortlist() {
      if (this.listing) {
        for (let shortlist of this.shortlists) {
          for (let listing of shortlist.listings) {
            if (listing.id === this.listing.id) {
              return true;
            }
          }
        }
      }

      return false;
    },
    isHirer() {
      return this.$store.getters["user/isHirer"];
    },
    isLoggedIn() {
      return this.$store.getters["user/account"];
    },
    shortlists() {
      return this.$store.getters["user/shortlists"];
    },
  },
  watch: {
    isSelected() {
      this.$emit(this.isSelected ? "selected" : "deselected");
    },
    selected() {
      if (this.isSelected !== this.selected) {
        this.isSelected = this.selected;
      }
    },
  },
  methods: {
    toggleFocus(e) {
      e.preventDefault();
      if (!this.$store.getters["user/account"]) {
        return this.$store.commit("user/changeAuthMode", "login");
      }
      if(typeof this.setShowShortlistMenu === 'function') {
        this.setShowShortlistMenu(true);
      } else {
        this.viewAllShortlists();
      }
    },
    viewAllShortlists() {
      this.$store
        .dispatch("modals/show", {
          type: "shortlist-view-all",
          maskCanDismiss: false,
          headless: true,
          narrow: true,
          fixedFooter: true,
          data: {
            listing: this.listing,
            selected: this.selected
          }
        });
    },
  },
};
</script>
